(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brador-material-marquee"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-brador-marquee]').forEach((root) => {
    const toggle = root.querySelector('[data-brador-marquee-toggle]');
    const track = root.querySelector('.brador-marquee__track');
    const rows = Array.from(root.querySelectorAll('.brador-marquee__row'));

    const setPaused = (paused) => {
      root.classList.toggle('is-paused', paused);
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute(
          'aria-label',
          paused ? 'Play scrolling collections' : 'Pause scrolling collections'
        );
      }
    };

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setPaused(prefersReduced);

    if (toggle) {
      toggle.addEventListener('click', () => setPaused(!root.classList.contains('is-paused')));
    }

    if (!track || !rows.length || prefersReduced) return;

    // --- Touch-swipe support: mobile keeps the auto-marquee running, ---
    // --- but a finger can grab it and scroll it manually at any time. ---
    const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
    if (!isCoarsePointer) return;

    root.classList.add('brador-marquee--js-driven');

    // Keeps a value within (-wrap, 0], looping infinitely either direction.
    const wrapOffset = (x, wrap) => {
      let r = x % wrap;
      if (r > 0) r -= wrap;
      return r;
    };

    const state = rows.map((row) => ({
      row,
      offset: 0,
      wrap: 1,
      speed: 0, // px per ms
      dir: row.classList.contains('brador-marquee__row--b') ? 1 : -1,
    }));

    const readVars = () => {
      const styles = getComputedStyle(track);
      state.forEach((s) => {
        const isRowB = s.dir === 1;
        const pct = parseFloat(
          styles.getPropertyValue(isRowB ? '--translate-b' : '--translate-a')
        ) || -50;
        const speedSec = parseFloat(
          styles.getPropertyValue(isRowB ? '--speed-b' : '--speed-a')
        ) || 42;
        const wrap = (Math.abs(pct) / 100) * s.row.scrollWidth;
        s.wrap = wrap || 1;
        s.speed = s.wrap / (speedSec * 1000);
      });
    };
    readVars();
    window.addEventListener('resize', readVars);

    const applyTransforms = () => {
      state.forEach((s) => {
        s.row.style.transform = `translateX(${s.offset}px)`;
      });
    };

    let dragging = false;
    let moved = false;
    let startX = 0;
    let dragStartOffsets = [];
    let lastTime = null;

    const tick = (time) => {
      if (lastTime === null) lastTime = time;
      const dt = time - lastTime;
      lastTime = time;

      if (!dragging && !root.classList.contains('is-paused')) {
        state.forEach((s) => {
          s.offset = wrapOffset(s.offset + s.dir * s.speed * dt, s.wrap);
        });
        applyTransforms();
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'touch') return;
      dragging = true;
      moved = false;
      lastTime = null;
      startX = e.clientX;
      dragStartOffsets = state.map((s) => s.offset);
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const delta = e.clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      state.forEach((s, i) => {
        s.offset = wrapOffset(dragStartOffsets[i] + delta, s.wrap);
      });
      applyTransforms();
    });

    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      if (moved) {
        // Swallow the click a swipe would otherwise fire on a tile link.
        const suppressClick = (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          track.removeEventListener('click', suppressClick, true);
        };
        track.addEventListener('click', suppressClick, true);
      }
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smartslider"] && !Shopify.designMode) return;
  try {
    
 function initSmartCarousels() {
    const sections = document.querySelectorAll('.smart-carousel-hero:not(.initialized)');
    
    sections.forEach(section => {
      section.classList.add('initialized');
      const viewport = section.querySelector('[data-smart-carousel-viewport]');
      const track = section.querySelector('[data-smart-carousel-track]');
      if (!viewport || !track) return;

      const slides = Array.from(track.children);
      if (slides.length <= 1) return; // No need for controls or autoplay if only 1 collection

      const prevButton = section.querySelector('[data-smart-carousel-prev]');
      const nextButton = section.querySelector('[data-smart-carousel-next]');
      let index = 0;
      let autoplayTimer; // Variable to hold our interval timer

      function update() {
        const offset = -index * viewport.clientWidth;
        track.style.transform = `translateX(${offset}px)`;
        
        // Update active slide for opacity transitions
        slides.forEach((slide, i) => {
          if (i === index) {
            slide.setAttribute('data-active', 'true');
          } else {
            slide.setAttribute('data-active', 'false');
          }
        });
      }

      function goTo(delta) {
        index = (index + delta + slides.length) % slides.length;
        if (document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }
        resetAutoplay(); // Restart the timer if someone manually clicks an arrow
      }

      if (prevButton) {
        prevButton.addEventListener('click', () => goTo(-1));
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => goTo(1));
      }

      // --- AUTOPLAY LOGIC ---
      function startAutoplay() {
        autoplayTimer = setInterval(() => {
          goTo(1); // Moves to the next slide
        }, 5000); // 5000 milliseconds = 5 seconds. Change this number to adjust speed!
      }

      function resetAutoplay() {
        clearInterval(autoplayTimer);
        startAutoplay();
      }

      // Pause the sliding when a user hovers their mouse over the section
      section.addEventListener('mouseenter', () => {
        clearInterval(autoplayTimer);
      });
      
      // Resume sliding when they move their mouse away
      section.addEventListener('mouseleave', () => {
        startAutoplay();
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(update, 100);
      });
      
      update();
      startAutoplay(); // Kick off the autoplay when the page loads
    });
  }

  document.addEventListener('DOMContentLoaded', initSmartCarousels);
  document.addEventListener('shopify:section:load', initSmartCarousels);

  } catch(e) { console.error(e); }
})();
})();
